import React, { useEffect } from "react";
import { useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import { LogoutUser } from "../../Apis/loginApi";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Collapse from "@material-ui/core/Collapse";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavLink, useLocation } from "react-router-dom";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { withTranslation } from "react-i18next";
import Loader from "../Loader/loader";
import "./sidebar.css";
import sidebarLogo from "../../../assets/images/new_sidebar_logo.png";
import MobileAPKs from "../../APK's/mobileAPK's";
import isGHMC from "../../Common/helper/helpar";
import { jwtDecode } from "jwt-decode";
import { useHeaderStore } from "../Header/headerStore";

const Sidebar = ({ t, isSidebarOpen, loginPermission }) => {
  const { isSidebarMenuOpen, sidebarMenuOpen, sidebarMenuClose } = useHeaderStore();


  const location = useLocation();
  const dashboardsPageURLs = ["/sat-dashboard", "/asset-dashboard", "/scv-dashboard", "/gvp-dashboard","combined-dashboard", "/primary-dashboard", "/teritary-dashboard", "gps-dashboard"];
  const userManagementPageURLs = ["/roles", "/users", "/active-users"];
  const mobileUsersPageURLs = ["/scv-drivers", "/primary-deployment-charge-master", "/secondary-deployment-incharges", "/transferstation-incharge", "/traffic-marshal", "/loading-equipment-driver-details"];
  const organizationStructurePageURLs = ["/corporation", "/organization-zone", "/organization-circle", "/organization-ward", "/shifts", "/transferStation"];
  const assetsMastersPageURLs = ["/vehicle-type", "/vehicle-capacity", "/owner-type", "/vehicles", "/loading-equipment", "/Containers","allocated-master"];
  const attendanceMastersPageURLs = ["/operations", "/designations", "/employee"];
  const IEMastersPageURLs = ["/ts-feedback-category", "/hygiene-observation", "/independent-engineer"];
  const mastersPageURLs = ["/collection-points", "/routes", "/deployment-locations", ...assetsMastersPageURLs, ...organizationStructurePageURLs, ...attendanceMastersPageURLs, ...IEMastersPageURLs];
  const SATsReportsPageURLs = ["/day_detail_report", "/trip_tssctp"];
  const SCVReportsPageURLs = ["/scv_report_circle", "/scv-deployed-trips"];
  const TTRReportsPageURLs = ["/trips-tonnage-reports", "/hook_loader_report", "/container_report"];
  const GVPReportsPageURLs = ["/gvp-report", "/gvp-report-date", "/gvp-multiple-clearence", "/gvp-clearance-report"];
  const transactionModuleReportsPageURLs = ["/primary-deployment-transaction-report", "/secondary-deployment-transaction-report", "/deployed-hookloader-report", "/secondary-collection-transaction", "/deployed-container-transaction", "/all-transferstation-transaction", "/container-hookloader-transaction", "/traffic-marshal-transaction-report", "/tertiary-deployment-details", "/tertiary-trip-details"];
  const geofenceReportsPageURLs = ["/geofence-summary", "/geofence-vehicle-reports", "/geofence-vehicle-summary-reports"];
  const loadingEquipmentReportsPageURLs = ["/loading_equipment_deployment-summary-report", "/loading_equipment_certification-report", "/loading_equipment_clearance-report", "/contractor-wise-report"];
  const trafficMarshalReportsPageURLs = ["/unloading-wait-time", "/vehicle-total-weightment", "/live-reports", "/summary-reports"];
  const tertiaryReportsPageURLs = ["/deployment-report-teritary", "/trip-report-teritary", "/summary-report-teritary"];
  const kpiReportsPageURLs = ["/tipping-fee-calculation-report", "/no-of-bins-report", "/frequency-bins-report", "/msw-management-vehicles-report", "/msw-management-tertiary-vehicles-report", "/hygiene-transportation-report", "/transferstation-monthly-report", "/tonnage-composition-report"];
  const attendanceReportsPageURLs = ["/attendance-summary-report", "/attendance-daily-report", "/month-wise-attendance-summary-report"];
  const grievanceReportsPageURLs = ["/grievance-detailed-report"];
  const reportsPageURLS = [...SATsReportsPageURLs, ...SCVReportsPageURLs, ...TTRReportsPageURLs, ...GVPReportsPageURLs, ...transactionModuleReportsPageURLs, ...geofenceReportsPageURLs, ...loadingEquipmentReportsPageURLs, trafficMarshalReportsPageURLs, ...trafficMarshalReportsPageURLs, ...tertiaryReportsPageURLs, ...attendanceReportsPageURLs, ...grievanceReportsPageURLs, ...kpiReportsPageURLs];


  const [prodclassName, setProdClassName] = useState('');

  // const [permissions, setPermissions] = useState([]);
  const classes = useStyles();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [activeSection, setActiveSection] = React.useState(() => {
    if (dashboardsPageURLs.includes(location.pathname)) return "dashboards";
    if (mastersPageURLs.includes(location.pathname)) return "masters";
    if (reportsPageURLS.includes(location.pathname)) return "reports";
    if (userManagementPageURLs.includes(location.pathname)) return "userManagement";
    if (mobileUsersPageURLs.includes(location.pathname)) return "mobileUsers";
    return null;
  });
  const [activeMasterSub, setActiveMasterSub] = React.useState(() => {
    if (organizationStructurePageURLs.includes(location.pathname)) return "organization";
    if (assetsMastersPageURLs.includes(location.pathname)) return "assets";
    if (attendanceMastersPageURLs.includes(location.pathname)) return "attendance";
    if (IEMastersPageURLs.includes(location.pathname)) return "ie";
    return null;
  });
  const [activeReportSub, setActiveReportSub] = React.useState(() => {
    if (SATsReportsPageURLs.includes(location.pathname)) return "sat";
    if (SCVReportsPageURLs.includes(location.pathname)) return "scv";
    if (TTRReportsPageURLs.includes(location.pathname)) return "ttr";
    if (GVPReportsPageURLs.includes(location.pathname)) return "gvp";
    if (transactionModuleReportsPageURLs.includes(location.pathname)) return "transaction";
    if (geofenceReportsPageURLs.includes(location.pathname)) return "geofence";
    if (loadingEquipmentReportsPageURLs.includes(location.pathname)) return "loadingEquipment";
    if (trafficMarshalReportsPageURLs.includes(location.pathname)) return "trafficMarshal";
    if (tertiaryReportsPageURLs.includes(location.pathname)) return "tertiary";
    if (kpiReportsPageURLs.includes(location.pathname)) return "kpi";
    if (attendanceReportsPageURLs.includes(location.pathname)) return "attendance";
    if (grievanceReportsPageURLs.includes(location.pathname)) return "grievance";
    return null;
  });
  const [isLoading, setLoading] = React.useState(false);

  const isProd = isGHMC();



  useEffect(() => {
    // Set the class based on the isGHMC function's return value
    if (isGHMC()) {
      setProdClassName('ghmc-true');
    } else {
      setProdClassName('ghmc-false');
    }
  }, []);


  // Function to fetch permissions (replace with actual API call)

  const permissions = [
    "OrganiZation",
    "Assets",
    "Role Creations",
    "User Creations",
    "Shifts",
    "Collection Points",
    "Routes",
    "Transfer Station",
    "Containers",
    "Deployment Locations",
    "Primary Deployment",
    "Secondary Deployment InCharges",
    "Route Tracking",
    "SATs Reports",
    "SCV Reports",
    "TTR Reports",
    "GVP Reports",
    "GWP Reports",
    "TS/SCTP View",
    "C&D Waste Management",
    "Employee Attendance Report",
    "Citizen Confirmation Report",
    "Toilet Status Report",
    "ESM Reports",
    "BLO Reports",
    "User Log Reports",
    "MobileAPKs"
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const hasDashboardPermission = () => {
    return userPermissionCategory?.includes("Dashboard");
  };
  const hasPrimaryDashboardPermission = () => {
    return userPermission?.includes("TS Primary Dashboard");
  };
  const hasTeritaryDashboardPermission = () => {
    return userPermission?.includes("TS Teritary Dashboard");
  };
  const hasGVPDashboardPermission = () => {
    return userPermission?.includes("GVPs Dashboard");
  };
  const hasSCVDashboardPermission = () => {
    return userPermission?.includes("SCVs Dashboard");
  };
  const hasSATDashboardPermission = () => {
    return userPermission?.includes("SATs Dashboard");
  };
  const hasOrganizationPermission = () => {
    return userPermissionCategory?.includes("Organization");
  };
  const hasZonePermission = () => {
    return userPermission?.includes("Zone");
  };
  const hasCirclePermission = () => {
    return userPermission?.includes("Circle");
  };
  const hasWardPermission = () => {
    return userPermission?.includes("Ward");
  };
  const hasHookLoaderPermission = () => {
    return userPermission?.includes("Hook Loader TTR Report");
  };
  const hasVehicleTypePermission = () => {
    return userPermission?.includes("Vehicle Type");
  };
  const hasVehicleCapacityPermission = () => {
    return userPermission?.includes("Vehicle Capacity");
  };
  const hasOwnerTypePermission = () => {
    return userPermission?.includes("Owner Type");
  };
  const hasVehiclePermission = () => {
    return userPermission?.includes("Vehicles");
  };
  const hasLoadingEquipmnetPermission = () => {
    return userPermission?.includes("Loading Equipments");
  };
  const hasShiftsPermission = () => {
    return userPermission?.includes("Shifts");
  };
  const hasCollectionPointsPermission = () => {
    return userPermission?.includes("Collection Points");
  };
  const hasRoutesPermission = () => {
    return userPermission?.includes("Routes");
  };
  const hasTransferStationPermission = () => {
    return userPermission?.includes("TransferStation");
  };
  const hasContainersPermission = () => {
    return userPermission?.includes("Containers");
  };
  const hasDeploymentLocationsPermission = () => {
    return userPermission?.includes("Deployment Locations");
  };
  // Add similar functions for other permissions as needed

  const hasPrimaryDeploymentPermission = () => {
    return userPermission?.includes("SFA InCharges");
  };
  const hasSecondaryDeploymentChargesPermission = () => {
    return userPermission?.includes("Secondary Deployment InCharges");
  };
  const hasTransferstationInchargesPermission = () => {
    return userPermission?.includes("TransferStation InCharge");
  };
  const hasTrafficMarshalUserPermission = () => {
    return userPermission?.includes("Traffic Marshal,");
  };
  const hasLoadingEquipmentDriverDetailsPermission = () => {
    return userPermission?.includes("Loading Equipment Driver Details");
  };

  const hasRouteTrackingPermission = () => {
    return userPermission?.includes("Route Tracking");
  };

  const hasSATsReportsPermission = () => {
    return userPermissionCategory?.includes("SATs Reports");
  };
  const hasLoadingEquipmentReportsPermission = () => {
    return userPermissionCategory?.includes("Loading Equipment Reports");
  };

  const hasSATsDetailedReportsPermission = () => {
    return userPermission?.includes("SAT Detailed Report");
  };
  const hasSATsTripsPermission = () => {
    return userPermission?.includes("SAT Trip to TS/SCTP");
  };
  const hasLoadingEquipmentCertificationPermission = () => {
    return userPermission?.includes("Loading Equipment Certification");
  };
  const hasLoadingEquipmentClearancePermission = () => {
    return userPermission?.includes("Loading Equipment Clearance Report");
  };
  const hasLoadingEquipmentPermission = () => {
    return userPermission?.includes("Loading Equipment Report");
  };
  const hasContractorWiseLoadingEquipmentPermission = () => {
    return userPermission?.includes("Contractor Wise Loading Equipment");
  };
  const hasSCVReportsPermission = () => {
    return userPermissionCategory?.includes("SCV Reports");
  };
  const hasSCVReportCirclePermission = () => {
    return userPermission?.includes("Reported SCVs at Circle");
  };
  const hasSCVDeployedTripsPermission = () => {
    return userPermission?.includes("SCVs Deployed Trips to TS/SCTP");
  };
  const hasSCVOverallTripsPermission = () => {
    return userPermission?.includes("SCVs Overall Trips to TS/SCTP");
  };
  const hasTTRReportsPermission = () => {
    return userPermissionCategory?.includes("TTR Reports");
  };

  const hasTransactionReports = () => {
    return userPermissionCategory?.includes("Transaction Reports");
  };
  const hasGWPReportsPermission = () => {
    return userPermission?.includes("GWP Reports");
  };

  const hasTrafficMarshalPermission = () => {
    return userPermission?.includes("Traffic Marshal Transaction Report");
  };
  const hasTeritaryDeploymentPermission = () => {
    return userPermission?.includes("Tertiary Deployment");
  };
  const hasTeritaryReportPermission = () => {
    return userPermissionCategory?.includes("Teritary Reports");
  };
  const hasTeritaryTripPermission = () => {
    return userPermission?.includes("Tertiary Trip");
  };
  const hasPrimaryDeploymentTransactionPermission = () => {
    return userPermission?.includes("Primary Deployment Transaction Report");
  };
  const hasSecondaryDeploymentTransactionPermission = () => {
    return userPermission?.includes("Secondary Deployment Transaction Report");
  };
  const hasHookLoaderDeploymentTransactionPermission = () => {
    return userPermission?.includes("Deloyment Hookloader Report");
  };
  const hasSecondaryCollectionTransactionReportPermission = () => {
    return userPermission?.includes("Secondary Collection Transaction");
  };
  const hasDeployedContainerTransactionReportPermission = () => {
    return userPermission?.includes("Deployed Container Transaction");
  };
  const hasAllTransfertationTransactionReportsPermission = () => {
    return userPermission?.includes("All Transfertation Transaction");
  };
  const hasContainerHookLoaderTransactionReportsPermission = () => {
    return userPermission?.includes("Container HookLoader Transaction");
  };
  const hasRolesPermission = () => {
    return userPermission?.includes("Roles");
  };
  const hasUserCreationsPermission = () => {
    return userPermission?.includes("Users");
  };

  const hasMasterCreatePermission = () => {
    return userPermissionCategory?.includes("User Management");
  };
  const hasActiveUserPermission = () => {
    return userPermission?.includes("Active Users");
  };
  const hasContainerPermission = () => {
    return userPermission?.includes("Container TTR Report");
  };

  const hasMasterAssetsPermission = () => {
    return userPermissionCategory?.includes("Assets");
  };

  const hasGeofenceReportsPermission = () => {
    return userPermissionCategory?.includes("Geofence Reports");
  };

  const hasGeofenceSummaryPermission = () => {
    return userPermission?.includes("Geofence Summary");
  };
  const hasTrafficMarshalReports = () => {
    return userPermissionCategory?.includes("Traffic Marshal Reports");
  };
  const hasSummaryReport = () => {
    return userPermission?.includes("Summary Reports");
  };
  const hasLiveReport = () => {
    return userPermission?.includes("Live Reports");
  };
  const hasUnloadingWaitTime = () => {
    return userPermission?.includes("Unloading Wait Time");
  };
  const hasVehicleTotalWeighment = () => {
    return userPermission?.includes("Vehicle Total Weighment");
  };
  const hasDeploymentPermission = () => {
    return userPermission?.includes("Deployment Report");
  };
  const hasTripSummaryPermission = () => {
    return userPermission?.includes("Trip Report");
  };

  const hasDeploymentSummaryPermission = () => {
    return userPermission?.includes("Deployment Summary Report");
  };

  const hasGeofenceVehicleSummaryPermission = () => {
    return userPermission?.includes("Geofence Vehicle Summary Report");
  };
  const hasGeofenceVehiclePermission = () => {
    return userPermission?.includes("Geofence Vehicle Report");
  };

  const hasMobileUsersPermission = () => {
    return userPermissionCategory?.includes("Mobile Users");
  };

  const hasDriverAppPermission = () => {
    return userPermission?.includes("Drivers");
  };

  const hasGVPReportPermission = () => {
    return userPermissionCategory?.includes("GVP Report");
  };
  const hasGVPOneReportPermission = () => {
    return userPermission?.includes("GVPs Report");
  };
  const hasGVPMultipleClearanceReportPermission = () => {
    return userPermission?.includes("GVP Multiple Clearance Report");
  };
  const hasGVPClearanceReportPermission = () => {
    return userPermission?.includes("GVP Clearance Report");
  };
  const hasGVPReportDatePermission = () => {
    return userPermission?.includes("GVPs Clearance Report - Date");
  };

  const hasMobileAPKsPermission = () => {
    return userPermission?.includes("Mobile APK's");
  };

  const hasTTRTripsTonnagePermission = () => {
    return userPermission?.includes("Trips & Tonnage Reports");
  };
  const userPermission = localStorage.getItem("loginPermissions");
  const userPermissionCategory = localStorage.getItem(
    "permissionCategoryNames"
  );
  let storedPermissionsData = JSON.parse(sessionStorage.getItem('permissionsData')) || [];
  let storedPermissions = storedPermissionsData.map((item) => item.permissionId)


  const handleLogout = async () => {
    const token = localStorage.getItem('token');
    let decodedToken = null;
    try {
      if (token) {
        decodedToken = jwtDecode(token);
        console.log('Decoded Token:', decodedToken);
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      toast.error("There was an issue with your session. Please log in again.");
      return; // Prevent further execution if the token can't be decoded
    }

    // Use decoded token values instead of null values
    const payload = {
      token,
      userId: decodedToken?.UserId || null,
      sessionId: decodedToken?.SessionId || null,
      userType: decodedToken?.UserType || null,
    };
    try {
      const response = await LogoutUser(payload); // Call the logout API
      if (response.statusCode === 404) {
        toast.error("Your session has already expired or is invalid.");
      } else {
        toast.success("You have been successfully logged out.");
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('userType');
        setIsLoggedIn(false);
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);  // Redirect to home page
      }
    } catch (error) {
      console.error('Logout failed:', error);
      toast.error("An error occurred during logout. Please try again.");
    }
  };


  const sidebarClassName = isSidebarOpen
    ? "app-sidebar sidebar-shadow closed-sidebar"
    : "sidebar-mobile-open .app-sidebar";

  const callPermissionFunction = (permissionId) => {
    localStorage.setItem('permissionId', permissionId);
  };
  const handleZoneClick = () => {
    callPermissionFunction(1); // Replace with your actual function name and logic
  };
  const handleCircleClick = () => {
    callPermissionFunction(2); // Replace with your actual function name and logic
  };
  const handleWardClick = () => {
    callPermissionFunction(3); // Replace with your actual function name and logic
  };

  const handleVehicleTypeClick = () => {
    callPermissionFunction(4); // Replace with your actual function name and logic
  };

  const handleVehicleCapacityClick = () => {
    callPermissionFunction(5); // Replace with your actual function name and logic
  };

  const handleOwnerTypeClick = () => {
    callPermissionFunction(6); // Replace with your actual function name and logic
  };
  const handleVehiclesClick = () => {
    callPermissionFunction(7); // Replace with your actual function name and logic
  };

  const handleLoadingEuipmentClick = () => {
    callPermissionFunction(8); // Replace with your actual function name and logic
  };
  const handleShiftsClick = () => {
    callPermissionFunction(9); // Replace with your actual function name and logic
  };

  const handleCollectionPointsClick = () => {
    callPermissionFunction(10); // Replace with your actual function name and logic
  };

  const handleRouteClick = () => {
    callPermissionFunction(11); // Replace with your actual function name and logic
  };

  const handleTransferStationClick = () => {
    callPermissionFunction(12); // Replace with your actual function name and logic
  };

  const handleContainersClick = () => {
    callPermissionFunction(13); // Replace with your actual function name and logic
  };

  const handleDeploymentLocationsClick = () => {
    callPermissionFunction(14); // Replace with your actual function name and logic
  };

  const handleRolesClick = () => {
    callPermissionFunction(23); // Replace with your actual function name and logic
  };

  const handleUsersClick = () => {
    callPermissionFunction(24); // Replace with your actual function name and logic
  };

  const handleScvDriverClick = () => {
    callPermissionFunction(25); // Replace with your actual function name and logic
  };

  const handleSFAInchargesClick = () => {
    callPermissionFunction(26); // Replace with your actual function name and logic
  };

  const handleSecondaryDeploymentInchargeClick = () => {
    callPermissionFunction(27); // Replace with your actual function name and logic
  };

  const handleTransferStationInchargeClick = () => {
    callPermissionFunction(28); // Replace with your actual function name and logic
  };

  const handleTrafficMarshaltClick = () => {
    callPermissionFunction(50); // Replace with your actual function name and logic
  };

  const handleGvpReportsClick = () => {
    callPermissionFunction(35); // Replace with your actual function name and logic
  };
  return (
    <div className={sidebarClassName}>
      <div className={`navigation ${isSidebarMenuOpen ? "open" : ""} ${prodclassName}`} style={{ overflow: "hidden" }} >
        <div className="navigation-header">
          <span>Navigation</span>
          <a href="#" onClick={() => sidebarMenuClose()}>
            <i className={`ti-close ${isProd ? "icon-blue" : "icon-red"}`}></i>
          </a>
        </div>
        <div
          className="navigation-menu-body"
          style={{
            overflowY: activeSection === "masters" || activeMasterSub === "organization" || activeMasterSub === "assets" || activeSection === "reports" || activeReportSub === "ttr" ? "scroll" : "scroll",
            overflowX: "hidden"
          }}
        >
          <div className="header-logo">
            <a>
              <img className="logo" src={sidebarLogo} alt="logo" />
            </a>
          </div>
          <List

            className={classes.appMenu}
            disablePadding
            style={{ color: "black", marginBottom: "30px", marginTop: "10px" }}
          >
            {hasDashboardPermission("Dashboard") && (
              <ListItem
                button
                onClick={() => setActiveSection(activeSection === "dashboards" ? null : "dashboards")}
                className={`${isProd ? (activeSection === "dashboards" ? "bg-ghmc" : "bg-transparent") : (activeSection === "dashboards" ? "bg-swm" : "bg-transparent")}`}
                component={NavLink}
              >
                <ListItemIcon
                  className={classes.menuItemIcon}

                >
                  <i
                    className={`fa fa-tachometer-alt ${isProd ? "icon-blue" : "icon-red"}`}

                  ></i>{" "}
                </ListItemIcon>
                <ListItemText primary={t("dashboard")} />
                {activeSection === "dashboards" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>
            )}
            <Collapse in={activeSection === "dashboards"} timeout="auto" unmountOnExit>
              {/* gps dashboard */}

              {/* {hasDashboardPermission("DashBoard") &&
                hasSCVDashboardPermission("GPS Dashboard") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/gps-dashboard"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/gps-dashboard"
                    style={{
                      display: "flex"
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("GPS Dashboard")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/gps-dashboard"}
                  </ListItem>
                )} */}
                
                
                  { userPermission?.includes("Dashboard") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/combined-dashboard"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/combined-dashboard"
                    style={{
                      display: "flex"
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Dashboard")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/combined-dashboard" && <ActiveIndicator />}
                  </ListItem>
                )}

              {/* {hasDashboardPermission("DashBoard") &&
                hasSATDashboardPermission("SATs Dashboard") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/sat-dashboard"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/sat-dashboard"
                    style={{
                      display: "flex"
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("SATs Dashboard")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/sat-dashboard" && <ActiveIndicator />}
                  </ListItem>
                )}
              {hasDashboardPermission("DashBoard") &&
                hasSCVDashboardPermission("SCVs Dashboard") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/scv-dashboard"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/scv-dashboard"
                    style={{
                      display: "flex"
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("SCVs Dashboard")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/scv-dashboard" && <ActiveIndicator />}
                  </ListItem>
                )}

              {hasDashboardPermission("DashBoard") &&
                hasGVPDashboardPermission("GVPs Dashboard") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/gvp-dashboard"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/gvp-dashboard"
                    style={{
                      display: "flex"
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("GVPs Dashboard")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/gvp-dashboard" && <ActiveIndicator />}
                  </ListItem>
                )} */}

              { userPermission?.includes("Asset Dashboard") &&(
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/asset-dashboard"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/asset-dashboard"
                    style={{
                      display: "flex"
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Asset Dashboard")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/asset-dashboard" && <ActiveIndicator />}
                  </ListItem>
                )}

              {/* roleCreation */}
              {userPermission?.includes("Transfer Station Dashboard") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    component={NavLink}
                    to="/primary-dashboard"
                    style={{
                      display: "flex",
                      borderRadius: "0px",
                    }}
                    className={`${classes.menuItem} ${location.pathname === "/primary-dashboard"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                  >
                    <ListItemText
                      inset
                      primary={t("Transfer Station Dashboard")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/primary-dashboard" && <ActiveIndicator />}
                  </ListItem>
                )}

              {userPermission?.includes("Tertiary Dashboard") &&(
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/teritary-dashboard"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/teritary-dashboard"
                    style={{
                      display: "flex"
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Tertiary Dashboard")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/teritary-dashboard" && <ActiveIndicator />}
                  </ListItem>
                )}
              {/* userCreation */}
            </Collapse>

            {/* )} */}
            {hasOrganizationPermission("Organization") ||
              hasMasterAssetsPermission("Assets") ||
              hasCollectionPointsPermission("Collection Points") ||
              hasRoutesPermission("Routes") ||
              userPermissionCategory?.includes("Attendance") ||
              userPermissionCategory?.includes("IE") ||
              hasDeploymentLocationsPermission("Deployment Locations") ? (
              <ListItem
                button
                onClick={() => setActiveSection(activeSection === "masters" ? null : "masters")}
                className={`
              ${classes.menuItem} 
              ${location.pathname.startsWith("/city-master") ||
                    location.pathname.startsWith("/companies") ||
                    location.pathname.startsWith("/organization") ||
                    location.pathname.startsWith("/shifts") ||
                    location.pathname.startsWith("/collectionpoint-details") ||
                    location.pathname.startsWith("/route-master") ||
                    location.pathname.startsWith("/transfer-station-master") ||
                    location.pathname.startsWith("/container-master") ||
                    location.pathname.startsWith("/deployment-location-master") ||
                    location.pathname.startsWith("/deployment-charge-master") ||
                    location.pathname.startsWith("/driver-creation") ||
                    location.pathname.startsWith("/owner-type") ||
                    location.pathname.startsWith("/vehicle-type") ||
                    location.pathname.startsWith("/vehicle") ||
                    location.pathname === "/routeTracking"
                    ? `${isProd ? "active-ghmc" : "active-swmnew"} icon-white`
                    : ""
                  } 
              ${isProd ? (activeSection === "masters" ? "bg-ghmc" : "bg-transparent") : (activeSection === "masters" ? "bg-swm" : "bg-transparent")}`}
                activeClassName="active-link"
                style={{
                  left: "1.5px",
                }}
              >
                <ListItemIcon className={classes.menuItemIcon} >
                  <i className={`fa-solid fa-gear ${isProd ? "icon-blue" : "icon-red"} icon-white`}></i>
                </ListItemIcon>
                <ListItemText primary={t("masters")} style={{ marginLeft: "" }} />
                {activeSection === "masters" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>
            ) : ""}
            <Collapse in={activeSection === "masters"} timeout="auto" unmountOnExit>
              <Divider />
              <List component="div" disablePadding>
              </List>
              <div>
                {/* Organization */}
                <>
                  {hasOrganizationPermission("Organization") ||
                    hasZonePermission("Zone") ||
                    hasCirclePermission("Circle") ||
                    hasWardPermission("Ward") ||
                    hasShiftsPermission("Shifts") ? (
                    <ListItem
                      button
                      onClick={() => setActiveMasterSub(activeMasterSub === "organization" ? null : "organization")}
                      className={activeMasterSub === "organization" ? "sub-section-open" : ""}
                      style={{
                        display: hasOrganizationPermission("Organization")
                          ? "block d-flex"
                          : "none",
                      }}
                    >
                      <ListItemText
                        inset
                        primary={t("organizationStructure")}
                        style={{
                          // width: "100%",
                          paddingLeft: "25px",
                        }}
                      />
                      {activeMasterSub === "organization" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </ListItem>
                  ) : ""}
                  <Collapse in={activeMasterSub === "organization"} timeout="auto" className="level-4" unmountOnExit>

                    {userPermission?.includes("Corporation") &&(
                      <>
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/corporation"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/corporation"
                          style={{
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Corporation")}
                            style={{ paddingLeft: "25px" }}
                          // onClick={handleZoneClick}
                          />
                          {location.pathname === "/corporation" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      </>
                    )}
                    {hasOrganizationPermission("Organization") &&
                      hasZonePermission("Zone") && (
                        <>
                          <ListItem
                            onClick={() => sidebarMenuClose()}
                            button
                            className={`${classes.menuItem} ${location.pathname === "/organization-zone"
                              ? isProd
                                ? "active-ghmc"
                                : "active-swmnew"
                              : ""
                              }`}
                            component={NavLink}
                            to="/organization-zone"
                            style={{
                              left: "1.5px",
                            }}
                          >
                            <ListItemText
                              inset
                              primary={t("zones")}
                              style={{ paddingLeft: "25px" }}
                              onClick={handleZoneClick}
                            />
                            {location.pathname === "/organization-zone" && (
                              <ActiveIndicator />
                            )}
                          </ListItem>
                        </>
                      )}
                    {hasOrganizationPermission("Organization") &&
                      hasCirclePermission("Circle") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/organization-circle"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/organization-circle"
                          style={{
                            left: "1.5px",
                            // paddingLeft:  "25px"
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("circles")}
                            style={{ paddingLeft: "25px" }}
                            onClick={handleCircleClick}
                          />
                          {location.pathname === "/organization-circle" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasOrganizationPermission("Organization") &&
                      hasWardPermission("Ward") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/organization-ward"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/organization-ward"
                          style={{
                            left: "1.5px",
                            // paddingLeft:  "25px"
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("wards")}
                            style={{ paddingLeft: "25px" }}
                            onClick={handleWardClick}
                          />
                          {location.pathname === "/organization-ward" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasOrganizationPermission("Organization") &&
                      hasShiftsPermission("Shifts") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/shifts"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/shifts"
                          style={{
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("shiftMaster")}
                            style={{ paddingLeft: "25px" }}
                            onClick={handleShiftsClick}
                          />
                          {location.pathname === "/shifts" && <ActiveIndicator />}
                        </ListItem>
                      )}
                    {hasTransferStationPermission("TransferStation") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/transferStation"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/transferStation"
                        style={{
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("transferStations")}
                          style={{ paddingLeft: "25px" }}
                          onClick={handleTransferStationClick}
                        />
                        {location.pathname === "/transferStation" && (
                          <ActiveIndicator />
                        )}
                      </ListItem>
                    )}

                  </Collapse>
                </>
                <>
                  {hasMasterAssetsPermission("Assets") || hasContainersPermission("Containers") ? (
                    <ListItem button onClick={() => setActiveMasterSub(activeMasterSub === "assets" ? null : "assets")} className={activeMasterSub === "assets" ? "sub-section-open" : ""}>
                      <ListItemText
                        inset
                        primary={t("assetMaster")}
                        className={`$`}
                        style={{ paddingLeft: "25px" }}
                      />
                      {activeMasterSub === "assets" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </ListItem>
                  ) : ""}
                  <Collapse in={activeMasterSub === "assets"} timeout="auto" unmountOnExit className="level-4">
                    {hasVehicleTypePermission("Vehicle Type") &&
                      hasMasterAssetsPermission("Assets") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/vehicle-type"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/vehicle-type"
                          style={{
                            left: "1.5px",

                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("vehicle_type")}
                            style={{ paddingLeft: "25px" }}
                            onClick={handleVehicleTypeClick}
                          />
                          {location.pathname === "/vehicle-type" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasVehicleCapacityPermission("Vehicle Capacity") &&
                      hasMasterAssetsPermission("Assets") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/vehicle-capacity"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/vehicle-capacity"
                          style={{
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Vehicle Capacity")}
                            style={{ paddingLeft: "25px" }}
                            onClick={handleVehicleCapacityClick}
                          />
                          {location.pathname === "/vehicle-capacity" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasOwnerTypePermission("Owner Type") &&
                      hasMasterAssetsPermission("Assets") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/owner-type"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/owner-type"
                          style={{
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("ownerType")}
                            style={{ paddingLeft: "25px" }}
                            onClick={handleOwnerTypeClick}
                          />
                          {location.pathname === "/owner-type" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasVehiclePermission("Vehicles") &&
                      hasMasterAssetsPermission("Assets") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/vehicles"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/vehicles"
                          style={{
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("vehicle")}
                            style={{ paddingLeft: "25px" }}
                            onClick={handleVehiclesClick}
                          />
                          {location.pathname === "/vehicles" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}

                      {
                        userPermission?.includes("AllotedMaster") &&<ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/allocated-master"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/allocated-master"
                          style={{
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Allocated Master")}
                            style={{ paddingLeft: "25px" }}
                            // onClick={handleAllocatedMasterClick}
                          />
                          {location.pathname === "/allocated-master" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      }

                    {hasLoadingEquipmnetPermission("Loading Equipments") &&
                      hasMasterAssetsPermission("Assets") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/loading-equipment"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/loading-equipment"
                          style={{
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("loadingEquipment")}
                            style={{ paddingLeft: "25px" }}
                            onClick={handleLoadingEuipmentClick}
                          />
                          {location.pathname === "/loading-equipment" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasContainersPermission("Containers") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/Containers"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/Containers"
                        style={{
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("containers")}
                          style={{ paddingLeft: "25px" }}
                          onClick={handleContainersClick}
                        />
                        {location.pathname === "/Containers" && <ActiveIndicator />}
                      </ListItem>
                    )}
                  </Collapse>
                </>
                {/* shift */}
                {userPermissionCategory?.includes("Attendance") &&
                  <ListItem button onClick={() => setActiveMasterSub(activeMasterSub === "attendance" ? null : "attendance")} className={activeMasterSub === "attendance" ? "sub-section-open" : ""}>
                    <ListItemText
                      inset
                      primary="Attendance"
                      className={`$`}
                      style={{ paddingLeft: "25px" }}
                    />
                    {activeMasterSub === "attendance" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>}
                <Collapse in={activeMasterSub === "attendance"} timeout="auto" unmountOnExit className="level-4">
                  {userPermission?.includes("Operations") &&
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/operations"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/operations"
                      style={{
                        left: "1.5px",
                      }}
                    >
                      <ListItemText
                        inset
                        primary="Operations"
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/operations" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  }
                  {userPermission?.includes("Designations") &&
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/designations"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/designations"
                      style={{
                        left: "1.5px",

                      }}
                    >
                      <ListItemText
                        inset
                        primary="Designations"
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/designations" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  }
                  {userPermission?.includes("Employee") &&
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/employee"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/employee"
                      style={{
                        left: "1.5px",

                      }}
                    >
                      <ListItemText
                        inset
                        primary="Employee"
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/employee" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  }
                </Collapse>
                {userPermissionCategory?.includes("IE") &&
                  <ListItem button onClick={() => setActiveMasterSub(activeMasterSub === "ie" ? null : "ie")} className={activeMasterSub === "ie" ? "sub-section-open" : ""}>
                    <ListItemText
                      inset
                      primary="IE"
                      className={`$`}
                      style={{ paddingLeft: "25px" }}
                    />
                    {activeMasterSub === "ie" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>}



                <Collapse in={activeMasterSub === "ie"} timeout="auto" unmountOnExit className="level-4">
                  {userPermission?.includes("Independent Engineer") &&
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/independent-engineer"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/independent-engineer"
                      style={{
                        left: "1.5px",
                      }}
                    >
                      <ListItemText
                        inset
                        primary="Independent Engineer"
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/independent-engineer" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  }
                  {userPermission?.includes("Hygiene Observation") &&
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/hygiene-observation"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/hygiene-observation"
                      style={{
                        left: "1.5px",

                      }}
                    >
                      <ListItemText
                        inset
                        primary="Hygiene Observation"
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/hygiene-observation" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  }
                  {userPermission?.includes("Transferstation Feedback Category") &&
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/ts-feedback-category"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/ts-feedback-category"
                      style={{
                        left: "1.5px",

                      }}
                    >
                      <ListItemText
                        inset
                        primary="Transferstation Feedback Category"
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/ts-feedback-category" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  }
                </Collapse>
                {hasCollectionPointsPermission("Collection Points") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/collection-points"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/collection-points"
                    style={{
                      left: "1.5px",
                      display: hasCollectionPointsPermission("Collection Points")
                        ? "block"
                        : "none",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("gvpMaster")}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleCollectionPointsClick}
                    />
                    {location.pathname === "/collection-points" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                )}
                {hasDeploymentLocationsPermission("Deployment Locations") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/deployment-locations"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/deployment-locations"
                    style={{
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("deploymentLocations")}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleDeploymentLocationsClick}
                    />
                    {location.pathname === "/deployment-locations" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                )}
                {/* <ListItem
                          onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/tipping-fee"
                    ? isProd
                      ? "active-ghmc"
                      : "active-swmnew"
                    : ""
                    }`}
                  component={NavLink}
                  to="/tipping-fee"
                  style={{
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    inset
                    primary={t("Tipping Fee")}
                    style={{ paddingLeft: "25px" }}
                  // onClick={handleDeploymentLocationsClick}
                  />
                  {location.pathname === "/tipping-fee" && (
                    <ActiveIndicator />
                  )}
                </ListItem> */}
              </div>
            </Collapse>
            {/* reports */}
            {hasSATsReportsPermission("SATs Reports") ||
              hasSCVReportsPermission("SCV Reports") ||
              hasTransactionReports("Transaction Reports") ||
              hasGVPReportPermission("GVP Report") ||
              hasGeofenceReportsPermission("Geofence Reports") ||
              hasTTRReportsPermission("TTR Reports") ||
              hasLoadingEquipmentReportsPermission("Loading Equipment Reports") ||
              hasTrafficMarshalReports("Traffic Marshal Reports") ||
              hasLoadingEquipmentClearancePermission("Loading Equipment Clearance Report") ||
              userPermissionCategory?.includes("Attendance Reports") ||
              hasTeritaryReportPermission("Teritary Reports") ? (
              <ListItem
                button
                onClick={() => setActiveSection(activeSection === "reports" ? null : "reports")}
                className={`
                  ${classes.menuItem}
                  ${isProd ? (activeSection === "reports" ? "bg-ghmc" : "bg-transparent") : (activeSection === "reports" ? "bg-swm" : "bg-transparent")}`}
                activeClassName="active-link"
                style={{
                  left: "1.5px",
                }}
              >
                <ListItemIcon
                  className={classes.menuItemIcon}

                >
                  <i className={`fa-solid fa-file-lines ${isProd ? "icon-blue" : "icon-red"}`}></i>
                </ListItemIcon>
                <ListItemText primary={t("reports")} style={{ marginLeft: "" }} />
                {activeSection === "reports" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>
            ) : null}
            <Collapse in={activeSection === "reports"} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {hasSATsReportsPermission("SATs Reports") && (
                  <ListItem
                    button
                    onClick={() => setActiveReportSub(activeReportSub === "sat" ? null : "sat")}
                    className={`${classes.menuItem} ${activeReportSub === "sat" ? "sub-section-open" : ""}`}
                    activeClassName="active-link"
                    style={{
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      primary={t("SATs Reports")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {activeReportSub === "sat" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                )}

                {/* sat */}
                <Collapse in={activeReportSub === "sat"} timeout="auto" unmountOnExit className="level-4">
                  <List component="div" disablePadding >
                    {hasSATsDetailedReportsPermission("SAT Detailed Report") &&
                      hasSATsReportsPermission("SATs Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/day_detail_report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/day_detail_report"
                          style={{
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("SATs Day Detailed Report")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname === "/day_detail_report" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasSATsTripsPermission("SAT Trip to TS/SCTP") &&
                      hasSATsReportsPermission("SATs Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          // className={classes.menuItem}
                          component={NavLink}
                          to="/trip_tssctp"
                          style={{
                            left: "1.5px",
                          }}
                          className={`${classes.menuItem} ${location.pathname === "/trip_tssctp"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                        >
                          <ListItemText
                            inset
                            primary={t("SATs Trip to TS/SCTP")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname === "/trip_tssctp" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {/* old */}
                  </List>
                </Collapse>

                {/* sat */}
                {/* scv */}
                {hasSCVReportsPermission("SCV Reports") && (
                  <ListItem
                    button
                    onClick={() => setActiveReportSub(activeReportSub === "scv" ? null : "scv")}
                    className={`${classes.menuItem} ${activeReportSub === "scv" ? "sub-section-open" : ""}`}
                    activeClassName="active-link"
                    style={{
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      primary={t("SCV Reports")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {activeReportSub === "scv" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                )}
                {/* scv */}
                <Collapse in={activeReportSub === "scv"} timeout="auto" unmountOnExit className="level-4">
                  <List component="div" disablePadding>
                    {hasSCVReportCirclePermission("Reported SCVs at Circle") &&
                      hasSCVReportsPermission("SCV Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/scv_report_circle" ||
                            location.pathname ===
                            "/view-scvs-circle-report" ||
                            location.pathname ===
                            "/view-Gvp-clearence-report" ||
                            location.pathname === "/view-vehicle-inner-report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/scv_report_circle"
                          style={{ left: "1.5px" }}
                        >
                          <ListItemText
                            inset
                            primary={t("Reported SCVs at Circle")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {(location.pathname === "/scv_report_circle" ||
                            location.pathname ===
                            "/view-vehicle-inner-report" ||
                            location.pathname ===
                            "/view-Gvp-clearence-report" ||
                            location.pathname ===
                            "/view-scvs-circle-report") && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}

                    {hasSCVDeployedTripsPermission(
                      "SCVs Deployed Trips to TS/SCTP"
                    ) &&
                      hasSCVReportsPermission("SCV Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${["/scv-deployed-trips", "/view-inner-scv-circle-report", "/view-deployed-trips", '/deployed-trips-tssctp', "/view-overall-trips"].includes(location.pathname)
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/scv-deployed-trips"
                          style={{ left: "1.5px" }}
                        >
                          <ListItemText
                            inset
                            primary={t("SCVs Trips to TS/SCTP")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {["/scv-deployed-trips", "/view-inner-scv-circle-report", "/view-deployed-trips", '/deployed-trips-tssctp', "/view-overall-trips"].includes(location.pathname) && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                  </List>
                </Collapse>
                {/* scv */}
                {/* ttr */}
                {hasTTRReportsPermission("TTR Reports") && (
                  <ListItem
                    button
                    onClick={() => setActiveReportSub(activeReportSub === "ttr" ? null : "ttr")}
                    className={`${classes.menuItem} ${activeReportSub === "ttr" ? "sub-section-open" : ""}`}
                    activeClassName="active-link"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      primary={t("TTR Reports")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {activeReportSub === "ttr" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                )}
                {/* ttr */}

                <Collapse in={activeReportSub === "ttr"} timeout="auto" unmountOnExit className="level-4">
                  <List component="div" disablePadding>
                    {hasTTRTripsTonnagePermission(
                      "Trips & Tonnage Reports") &&
                      hasTTRReportsPermission("TTR Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/trips-tonnage-reports"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/trips-tonnage-reports"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Trips & Tonnage Reports")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname === "/trips-tonnage-reports" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasHookLoaderPermission(
                      "Hook Loader TTR Report"
                    ) &&
                      hasTTRReportsPermission("TTR Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/hook_loader_report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/hook_loader_report"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Hook Loader TTR Report")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname === "/hook_loader_report" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasContainerPermission(
                      "Container TTR Report"
                    ) &&
                      hasTTRReportsPermission("TTR Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/container_report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/container_report"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Container TTR Report")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname === "/container_report" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                  </List>
                </Collapse>
                {/* ttr */}
                {/* gvp */}
                {hasGVPReportPermission("GVP Report") && (
                  <ListItem
                    button
                    onClick={() => setActiveReportSub(activeReportSub === "gvp" ? null : "gvp")}
                    className={`${classes.menuItem} ${activeReportSub === "gvp" ? "sub-section-open" : ""}`}
                    activeClassName="active-link"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      primary={t("GVP Reports")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {activeReportSub === "gvp" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                )}

                {/* gvp */}
                <Collapse in={activeReportSub === "gvp"} timeout="auto" unmountOnExit className="level-4">
                  <List component="div" disablePadding>
                    {hasGVPReportPermission("GVP Report") &&
                      hasGVPOneReportPermission("GVPs Report") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/gvp-report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/gvp-report"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("GVPs Report")}
                            style={{ paddingLeft: "25px" }}
                            onClick={handleGvpReportsClick}
                          />
                          {location.pathname === "/gvp-report" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {/* {hasGVPReportPermission("GVP Report") &&
                      hasGVPReportDatePermission(
                        "GVPs Clearance Report - Date"
                      ) && (
                        <ListItem
                        onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/gvp-report-date"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/gvp-report-date"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("GVPs Clearance Report - Date")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname === "/gvp-report-date" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )} */}
                    {hasGVPReportPermission("GVP Report") &&
                      hasGVPMultipleClearanceReportPermission(
                        "GVP Multiple Clearance Report"
                      ) && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/gvp-multiple-clearence"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/gvp-multiple-clearence"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("GVP Multiple Clearance Report")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname === "/gvp-multiple-clearence" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                    {hasGVPReportPermission("GVP Report") &&
                      hasGVPClearanceReportPermission("GVP Clearance Report") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/gvp-clearance-report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                          component={NavLink}
                          to="/gvp-clearance-report"

                        >
                          <ListItemText
                            inset
                            primary={t("GVP Clearance Report")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname === "/gvp-clearance-report" && (
                            <ActiveIndicator />
                          )}
                        </ListItem>
                      )}
                  </List>
                </Collapse>
                {/* gvp */}
                {/* gwp */}
                {hasGWPReportsPermission("GWP Reports") && (
                  <ListItem
                    button
                    onClick={() => setActiveReportSub(activeReportSub === "gwp" ? null : "gwp")}
                    className={classes.menuItem}
                    activeClassName="active-link"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      primary={t("GWP Reports")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {activeReportSub === "gwp" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                )}
                {/* gwp */}
                <Collapse in={activeReportSub === "gwp"} timeout="auto" unmountOnExit className="level-4">
                  <List component="div" disablePadding>
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/gvp-multiple-clearence"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/gvp-multiple-clearence"
                      style={{
                        borderRadius: "0px",
                        left: "1.5px",
                      }}
                    >
                      <ListItemText
                        inset
                        primary={t("gvpMulti")}
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/gvp-multiple-clearence" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>

                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/gvp-day-clearence"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/gvp-day-clearence"
                      style={{
                        borderRadius: "0px",
                        left: "1.5px",
                      }}
                    >
                      <ListItemText
                        inset
                        primary={t("gvpDay")}
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/gvp-day-clearence" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  </List>
                </Collapse>
                {hasTransactionReports("Transaction Reports") && (
                  <ListItem
                    button
                    onClick={() => setActiveReportSub(activeReportSub === "transaction" ? null : "transaction")}
                    className={`${classes.menuItem} ${activeReportSub === "transaction" ? "sub-section-open" : ""}`}
                    activeClassName="active-link"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      primary={t("Transaction Module")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {activeReportSub === "transaction" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                )}
                {/* gwp */}
                <Collapse in={activeReportSub === "transaction"} timeout="auto" unmountOnExit className="level-4">
                  <List component="div" disablePadding>
                    {hasPrimaryDeploymentTransactionPermission(
                      "Primary Deployment Transaction Report"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/primary-deployment-transaction-report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/primary-deployment-transaction-report"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Primary Deployment Transaction Report")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/primary-deployment-transaction-report" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}

                    {hasSecondaryDeploymentTransactionPermission(
                      "Secondary Deployment Transaction Report"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/secondary-deployment-transaction-report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/secondary-deployment-transaction-report"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t(
                              "Secondary Deployment Transaction Report"
                            )}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/secondary-deployment-transaction-report" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}
                    {hasHookLoaderDeploymentTransactionPermission(
                      "Deloyment Hookloader Report"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/deployed-hookloader-report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/deployed-hookloader-report"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Deployed Hookloader Transaction Report")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/deployed-hookloader-report" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}

                    {hasSecondaryCollectionTransactionReportPermission(
                      "Secondary Collection Transaction"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/secondary-collection-transaction"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/secondary-collection-transaction"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Secondary Collection Transaction")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/secondary-collection-transaction" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}

                    {hasDeployedContainerTransactionReportPermission(
                      "Deployed Container Transaction"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/deployed-container-transaction"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/deployed-container-transaction"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Deployed Container Transaction")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/deployed-container-transaction" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}

                    {hasAllTransfertationTransactionReportsPermission(
                      "All Transfertation Transaction"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/all-transferstation-transaction"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/all-transferstation-transaction"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("All Transfer station Transaction")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/all-transferstation-transaction" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}

                    {hasContainerHookLoaderTransactionReportsPermission(
                      "Container HookLoader Transaction"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/container-hookloader-transaction"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/container-hookloader-transaction"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Container HookLoader Transaction")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/container-hookloader-transaction" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}
                    {hasTrafficMarshalPermission(
                      "Traffic Marshal Transaction Report"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/traffic-marshal-transaction-report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/traffic-marshal-transaction-report"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Traffic Marshal Transaction")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/traffic-marshal-transaction-report" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}
                    {hasTeritaryDeploymentPermission(
                      "Tertiary Deployment"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/tertiary-deployment-details"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/tertiary-deployment-details"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Tertiary Deployment")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/tertiary-deployment-details" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}
                    {hasTeritaryTripPermission(
                      "Tertiary Trip"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                          onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/tertiary-trip-details"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/tertiary-trip-details"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Teritary Trip")}
                            style={{ paddingLeft: "25px" }}
                          />
                          {location.pathname ===
                            "/tertiary-trip-details" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}
                  </List>
                </Collapse>
                {hasGeofenceReportsPermission("Geofence Reports") && (
                  <ListItem
                    button
                    onClick={() => setActiveReportSub(activeReportSub === "geofence" ? null : "geofence")}
                    className={`${classes.menuItem} ${activeReportSub === "geofence" ? "sub-section-open" : ""}`}
                    activeClassName="active-link"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      primary={t("Geofence Reports")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {activeReportSub === "geofence" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                )}

                <Collapse in={activeReportSub === "geofence"} timeout="auto" unmountOnExit className="level-4">
                  {hasGeofenceReportsPermission("Geofence Reports") &&
                    hasGeofenceSummaryPermission("Geofence Summary") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/geofence-summary"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/geofence-summary"
                        style={{
                          borderRadius: "0px",
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("Geofence Summary")}
                          style={{ paddingLeft: "25px" }}
                        />
                        {location.pathname === "/geofence-summary" && (
                          <ActiveIndicator />
                        )}
                      </ListItem>
                    )}
                  {hasGeofenceReportsPermission("Geofence Reports") &&
                    hasGeofenceVehiclePermission("Geofence Vehicle Report") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/geofence-vehicle-reports"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/geofence-vehicle-reports"
                        style={{
                          borderRadius: "0px",
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("Geofence Vehicle Report")}
                          style={{ paddingLeft: "25px" }}
                        />
                        {location.pathname === "/geofence-vehicle-reports" && (
                          <ActiveIndicator />
                        )}
                      </ListItem>
                    )}
                  {hasGeofenceReportsPermission("Geofence Reports") &&
                    hasGeofenceVehicleSummaryPermission("Geofence Vehicle Summary Report") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/geofence-vehicle-summary-reports"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/geofence-vehicle-summary-reports"
                        style={{
                          borderRadius: "0px",
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("Geofence Vehicle Summary Report")}
                          style={{ paddingLeft: "25px" }}
                        />
                        {location.pathname ===
                          "/geofence-vehicle-summary-reports" && (
                            <ActiveIndicator />
                          )}
                      </ListItem>
                    )}
                </Collapse>
              </List>

              {hasLoadingEquipmentReportsPermission("Loading Equipment Reports") ||
                hasLoadingEquipmentClearancePermission("Loading Equipment Clearance Report") ? (
                <ListItem
                  button
                  onClick={() => setActiveReportSub(activeReportSub === "loadingEquipment" ? null : "loadingEquipment")}
                  className={`${classes.menuItem} ${activeReportSub === "loadingEquipment" ? "sub-section-open" : ""}`}
                  activeClassName="active-link"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    primary={t("Loading Equipment Reports")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {activeReportSub === "loadingEquipment" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </ListItem>
              ) : ""}

              <Collapse in={activeReportSub === "loadingEquipment"} timeout="auto" unmountOnExit className="level-4">
                <List component="div" disablePadding>
                  {hasLoadingEquipmentReportsPermission("Loading Equipment Report") &&
                    hasLoadingEquipmentPermission("Loading Equipment Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/loading_equipment_deployment-summary-report"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/loading_equipment_deployment-summary-report"
                        style={{
                          borderRadius: "0px",
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("Loading Equipment Deployment Report")}
                          style={{ paddingLeft: "25px" }}
                        />
                        {location.pathname === "/loading_equipment_deployment-summary-report" && (
                          <ActiveIndicator />
                        )}
                      </ListItem>
                    )}
                  {hasLoadingEquipmentReportsPermission("Loading Equipment Report") &&
                    hasLoadingEquipmentCertificationPermission("Loading Equipment Certification") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/loading_equipment_certification-report"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/loading_equipment_certification-report"
                        style={{
                          borderRadius: "0px",
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("Loading Equipment Certification Report")}
                          style={{ paddingLeft: "25px" }}
                        />
                        {location.pathname === "/loading_equipment_deployment-summary-report" && (
                          <ActiveIndicator />
                        )}
                      </ListItem>
                    )}
                  {hasLoadingEquipmentClearancePermission("Loading Equipment Clearance Report") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/loading_equipment_clearance-report"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/loading_equipment_clearance-report"
                      style={{
                        borderRadius: "0px",
                        left: "1.5px",
                      }}
                    >
                      <ListItemText
                        inset
                        primary={t("Loading Equipment Clearance Report")}
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/loading_equipment_clearance-report" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  )}
                  {hasContractorWiseLoadingEquipmentPermission("Contractor Wise Loading Equipment") &&
                    hasLoadingEquipmentReportsPermission("Loading Equipment Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/contractor-wise-report"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/contractor-wise-report"
                        style={{
                          borderRadius: "0px",
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("Contractor Wise Monthly Report")}
                          style={{ paddingLeft: "25px" }}
                        />
                        {location.pathname === "/contractor-wise-report" && (
                          <ActiveIndicator />
                        )}
                      </ListItem>
                    )}
                </List>
              </Collapse>

              {hasTrafficMarshalReports("Traffic Marshal Reports") && (
                <ListItem
                  button
                  onClick={() => setActiveReportSub(activeReportSub === "trafficMarshal" ? null : "trafficMarshal")}
                  className={`${classes.menuItem} ${activeReportSub === "trafficMarshal" ? "sub-section-open" : ""}`}
                  activeClassName="active-link"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    primary={t("Traffic Marshal Reports")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {activeReportSub === "trafficMarshal" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </ListItem>
              )}

              <Collapse in={activeReportSub === "trafficMarshal"} timeout="auto" unmountOnExit className="level-4">
                {hasTrafficMarshalReports("Traffic Marshal Reports") &&
                  hasLiveReport("Live Report") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/live-reports"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/live-reports"
                      style={{
                        borderRadius: "0px",
                        left: "1.5px",
                      }}
                    >
                      <ListItemText
                        inset
                        primary="Live Reports"
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/live-reports" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  )}
                {hasTrafficMarshalReports("Traffic Marshal Reports") &&
                  hasSummaryReport("Summary Report") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/summary-reports"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/summary-reports"
                      style={{
                        borderRadius: "0px",
                        left: "1.5px",
                      }}
                    >
                      <ListItemText
                        inset
                        primary="Summary Reports"
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/summary-reports" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  )}
                {hasTrafficMarshalReports("Traffic Marshal Reports") &&
                  hasUnloadingWaitTime("Unloading Wait Time") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/unloading-wait-time"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/unloading-wait-time"
                      style={{
                        borderRadius: "0px",
                        left: "1.5px",
                      }}
                    >
                      <ListItemText
                        inset
                        primary={t("Unloading Wait Time")}
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname === "/unloading-wait-time" && (
                        <ActiveIndicator />
                      )}
                    </ListItem>
                  )}
                {hasTrafficMarshalReports("Traffic Marshal Reports") &&
                  hasVehicleTotalWeighment("Vehicle Total Weighment") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/vehicle-total-weightment"
                        ? isProd
                          ? "active-ghmc"
                          : "active-swmnew"
                        : ""
                        }`}
                      component={NavLink}
                      to="/vehicle-total-weightment"
                      style={{
                        borderRadius: "0px",
                        left: "1.5px",
                      }}
                    >
                      <ListItemText
                        inset
                        primary={t("Vehicle Total Weightment")}
                        style={{ paddingLeft: "25px" }}
                      />
                      {location.pathname ===
                        "/vehicle-total-weightment" && (
                          <ActiveIndicator />
                        )}
                    </ListItem>
                  )}
              </Collapse>
              {userPermissionCategory?.includes("Teritary Reports") && (
                <ListItem
                  button
                  onClick={() => setActiveReportSub(activeReportSub === "tertiary" ? null : "tertiary")}
                  className={`${classes.menuItem} ${activeReportSub === "tertiary" ? "sub-section-open" : ""}`}
                  activeClassName="active-link"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    primary={t("Tertiary Reports")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {activeReportSub === "tertiary" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </ListItem>
              )}

              <Collapse in={activeReportSub === "tertiary"} timeout="auto" unmountOnExit className="level-4">
                <List component="div" disablePadding>
                  {hasDeploymentPermission(
                    "Deployment Report") &&
                    hasTeritaryReportPermission("Teritary Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/deployment-report-teritary"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/deployment-report-teritary"
                        style={{
                          borderRadius: "0px",
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("Deployment Report")}
                          style={{ paddingLeft: "25px" }}
                        />
                        {location.pathname === "/deployment-report-teritary" && (
                          <ActiveIndicator />
                        )}
                      </ListItem>
                    )}

                </List>
                <List component="div" disablePadding>
                  {hasTripSummaryPermission(
                    "Trip Report") &&
                    hasTeritaryReportPermission("Teritary Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/trip-report-teritary"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/trip-report-teritary"
                        style={{
                          borderRadius: "0px",
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("Trip Report")}
                          style={{ paddingLeft: "25px" }}
                        />
                        {location.pathname === "/trip-report-teritary" && (
                          <ActiveIndicator />
                        )}
                      </ListItem>
                    )}

                </List>
                <List component="div" disablePadding>
                  {hasDeploymentSummaryPermission(
                    "Deployment Summary Report") &&
                    hasTeritaryReportPermission("Teritary Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/summary-report-teritary"
                          ? isProd
                            ? "active-ghmc"
                            : "active-swmnew"
                          : ""
                          }`}
                        component={NavLink}
                        to="/summary-report-teritary"
                        style={{
                          borderRadius: "0px",
                          left: "1.5px",
                        }}
                      >
                        <ListItemText
                          inset
                          primary={t("Deployment Summary Report")}
                          style={{ paddingLeft: "25px" }}
                        />
                        {location.pathname === "/summary-report-teritary" && (
                          <ActiveIndicator />
                        )}
                      </ListItem>
                    )}

                </List>
              </Collapse>

              {/* {hasTeritaryReportPermission("KPI Reports") && ( */}
              {userPermissionCategory?.includes("KPI Reports") && <ListItem
                button
                onClick={() => setActiveReportSub(activeReportSub === "kpi" ? null : "kpi")}
                className={`${classes.menuItem} ${activeReportSub === "kpi" ? "sub-section-open" : ""}`}
                activeClassName="active-link"
                style={{
                  borderRadius: "0px",
                  left: "1.5px",
                }}
              >
                <ListItemText
                  primary={t("KPI Reports")}
                  style={{ paddingLeft: "25px" }}
                />
                {activeReportSub === "kpi" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>}
              {/* )} */}



              <Collapse in={activeReportSub === "kpi"} timeout="auto" unmountOnExit className="level-4">

                {userPermission?.includes("KPI-01 Tipping Fee Calculation Report") && <ListItem
                  button
                  className={`${classes.menuItem} ${location.pathname === "/tipping-fee-calculation-report"
                    ? isProd
                      ? "active-ghmc"
                      : "active-swmnew"
                    : ""
                    }`}
                  component={NavLink}
                  to="/tipping-fee-calculation-report"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    inset
                    primary={t("KPI-01 Tipping Fee Calcualtion Report")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {location.pathname === "/tipping-fee-calculation-report" && (
                    <ActiveIndicator />
                  )}
                </ListItem>}



                {userPermission?.includes("KPI-02 No of Bins/GVPs Attended Daily Report") && <ListItem
                  button
                  className={`${classes.menuItem} ${location.pathname === "/no-of-bins-report"
                    ? isProd
                      ? "active-ghmc"
                      : "active-swmnew"
                    : ""
                    }`}
                  component={NavLink}
                  to="/no-of-bins-report"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    inset
                    primary={t("KPI-02 No of Bins/GVPs Attended Daily Report")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {location.pathname === "/no-of-bins-report" && (
                    <ActiveIndicator />
                  )}
                </ListItem>}


                {userPermission?.includes("KPI-03 Frequency Of Bins/GVPs Attended Daily Report") && <ListItem
                  button
                  className={`${classes.menuItem} ${location.pathname === "/frequency-bins-report"
                    ? isProd
                      ? "active-ghmc"
                      : "active-swmnew"
                    : ""
                    }`}
                  component={NavLink}
                  to="/frequency-bins-report"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    inset
                    primary={t("KPI-03 Frequency Of Bins/GVPs Attended Daily Report")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {location.pathname === "/frequency-bins-report" && (
                    <ActiveIndicator />
                  )}
                </ListItem>}
                {userPermission?.includes("KPI-05 MSW Management vehicles on the Road-Secondary Collection") && <ListItem
                  button
                  className={`${classes.menuItem} ${location.pathname === "/msw-management-vehicles-report"
                    ? isProd
                      ? "active-ghmc"
                      : "active-swmnew"
                    : ""
                    }`}
                  component={NavLink}
                  to="/msw-management-vehicles-report"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    inset
                    primary={t("KPI-05 MSW Management vehicles on the Road-Secondary Collection")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {location.pathname === "/msw-management-vehicles-report" && (
                    <ActiveIndicator />
                  )}
                </ListItem>}
                {userPermission?.includes("KPI-06 MSW Management vehicles on the Road-Tertiary Collection") && <ListItem
                  button
                  className={`${classes.menuItem} ${location.pathname === "/msw-management-tertiary-vehicles-report"
                    ? isProd
                      ? "active-ghmc"
                      : "active-swmnew"
                    : ""
                    }`}
                  component={NavLink}
                  to="/msw-management-tertiary-vehicles-report"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    inset
                    primary={t("KPI-06 MSW Management vehicles on the Road-Tertiary Collection")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {location.pathname === "/msw-management-tertiary-vehicles-report" && (
                    <ActiveIndicator />
                  )}
                </ListItem>}
                {userPermission?.includes("KPI-07 Hygiene Transportation Report") && <ListItem
                  button
                  className={`${classes.menuItem} ${location.pathname === "/hygiene-transportation-report"
                    ? isProd
                      ? "active-ghmc"
                      : "active-swmnew"
                    : ""
                    }`}
                  component={NavLink}
                  to="/hygiene-transportation-report"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    inset
                    primary={t("KPI-07 Hygiene Transportation Report")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {location.pathname === "/hygiene-transportation-report" && (
                    <ActiveIndicator />
                  )}
                </ListItem>}
                {userPermission?.includes("KPI-10 Transfer Station Management Report") && <ListItem
                  button
                  className={`${classes.menuItem} ${location.pathname === "/transferstation-monthly-report"
                    ? isProd
                      ? "active-ghmc"
                      : "active-swmnew"
                    : ""
                    }`}
                  component={NavLink}
                  to="/transferstation-monthly-report"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    inset
                    primary={t("KPI-10 Transfer Station Management Report")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {location.pathname === "/transferstation-monthly-report" && (
                    <ActiveIndicator />
                  )}
                </ListItem>}

                {userPermission?.includes("Tonnage Composition Report") && <ListItem
                  button
                  className={`${classes.menuItem} ${location.pathname === "/tonnage-composition-report"
                    ? isProd
                      ? "active-ghmc"
                      : "active-swmnew"
                    : ""
                    }`}
                  component={NavLink}
                  to="/tonnage-composition-report"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    inset
                    primary={t("Tonnage Composition Report")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {location.pathname === "/tonnage-composition-report" && (
                    <ActiveIndicator />
                  )}
                </ListItem>}

              </Collapse>





              {userPermissionCategory?.includes("Attendance Reports") &&
                <ListItem
                  button
                  onClick={() => setActiveReportSub(activeReportSub === "attendance" ? null : "attendance")}
                  className={`${classes.menuItem} ${activeReportSub === "attendance" ? "sub-section-open" : ""}`}
                  activeClassName="active-link"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    primary={t("Attendance Reports")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {activeReportSub === "attendance" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </ListItem>}
              <Collapse in={activeReportSub === "attendance"} timeout="auto" unmountOnExit className="level-4">
                {userPermission?.includes("Attendance Summary Report") &&
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/attendance-summary-report"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/attendance-summary-report"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Attendance Summary Report ")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/attendance-summary-report" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                }
                {userPermission?.includes("Daily Report") &&
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/attendance-daily-report"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/attendance-daily-report"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Daily Report")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/attendance-daily-report" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                }
                {userPermission?.includes("Month-wise Attendance Report Summary") &&
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/month-wise-attendance-summary-report"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/month-wise-attendance-summary-report"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Month-wise Attendance Report Summary")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/month-wise-attendance-summary-report" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                }
              </Collapse>


              {userPermissionCategory?.includes("Grievance Reports") &&
                <ListItem
                  button
                  onClick={() => setActiveReportSub(activeReportSub === "grievance" ? null : "grievance")}
                  className={`${classes.menuItem} ${activeReportSub === "grievance" ? "sub-section-open" : ""}`}
                  activeClassName="active-link"
                  style={{
                    borderRadius: "0px",
                    left: "1.5px",
                  }}
                >
                  <ListItemText
                    primary={t("Grievance Reports")}
                    style={{ paddingLeft: "25px" }}
                  />
                  {activeReportSub === "grievance" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </ListItem>}


              <Collapse in={activeReportSub === "grievance"} timeout="auto" unmountOnExit className="level-4">
                {userPermission?.includes("Grievance Detailed Report") &&
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/grievance-detailed-report"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/grievance-detailed-report"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Grievance Detailed Report ")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/grievance-detailed-report" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                }

              </Collapse>


            </Collapse>

            {hasMasterCreatePermission("User Management") && (
              <ListItem button
                onClick={() => setActiveSection(activeSection === "userManagement" ? null : "userManagement")}
                className={`
                  ${classes.menuItem}
                  ${isProd ? (activeSection === "userManagement" ? "bg-ghmc" : "bg-transparent") : (activeSection === "userManagement" ? "bg-swm" : "bg-transparent")}
                `}
              >

                <ListItemIcon className={classes.menuItemIcon} >
                  {/* <i className="fa-solid fa-user-group"></i> */}
                  <i className={`fa-solid fa-user ${isProd ? "icon-blue" : "icon-red"}`}></i>
                </ListItemIcon>
                <ListItemText
                  inset
                  primary={("User Management")}
                  style={{ paddingLeft: "0px" }}
                />
                {activeSection === "userManagement" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>

            )}
            <Collapse in={activeSection === "userManagement"} timeout="auto" unmountOnExit>
              {/* roleCreation */}
              {hasRolesPermission("Roles") &&
                hasMasterCreatePermission("User Management") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/roles"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/roles"
                    style={{
                      display: "flex",
                      borderRadius: "0px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("roleCreation")}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleRolesClick}
                    />
                    {location.pathname === "/roles" && <ActiveIndicator />}
                  </ListItem>
                )}
              {/* userCreation */}
              {hasUserCreationsPermission("Users") &&
                hasMasterCreatePermission("User Management") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/users"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/users"
                    style={{
                      borderRadius: "0px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("userCreation")}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleUsersClick}
                    />
                    {location.pathname === "/users" && <ActiveIndicator />}
                  </ListItem>
                )}
              {hasActiveUserPermission("Active Users") &&
                hasMasterCreatePermission("User Management") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/active-users"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/active-users"
                    style={{
                      borderRadius: "0px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={"Active Users"}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleUsersClick}
                    />
                    {location.pathname === "/active-users" && <ActiveIndicator />}
                  </ListItem>
                )}
            </Collapse>
            {hasMobileUsersPermission("Mobile Users") ||
              hasTrafficMarshalUserPermission("Traffic Marshal") ? (
              <ListItem button
                onClick={() => setActiveSection(activeSection === "mobileUsers" ? null : "mobileUsers")}
                className={`
                ${classes.menuItem}
                 ${isProd ? (activeSection === "mobileUsers" ? "bg-ghmc" : "bg-transparent") : (activeSection === "mobileUsers" ? "bg-swm" : "bg-transparent")}
                 `}
              >
                <ListItemIcon className={classes.menuItemIcon} >
                  <i className={`fa-solid fa-mobile-screen-button ${isProd ? "icon-blue" : "icon-red"}`}></i>
                </ListItemIcon>
                <ListItemText
                  inset
                  primary={("Mobile Users")}
                  style={{ paddingLeft: "0px" }}
                />
                {activeSection === "mobileUsers" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>
            ) : ""}
            <Collapse in={activeSection === "mobileUsers"} timeout="auto" unmountOnExit>
              {hasDriverAppPermission("Drivers") &&
                hasMobileUsersPermission("Mobile Users") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/scv-drivers"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/scv-drivers"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Drivers")}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleScvDriverClick}
                    />
                    {location.pathname === "/scv-drivers" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                )}
              {/* userCreation */}

              {hasPrimaryDeploymentPermission("SFA InCharges") &&
                hasMobileUsersPermission("Mobile Users") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/primary-deployment-charge-master"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/primary-deployment-charge-master"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("SFA Incharges")}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleSFAInchargesClick}
                    />
                    {location.pathname ===
                      "/primary-deployment-charge-master" && (
                        <ActiveIndicator />
                      )}
                  </ListItem>
                )}
              {/* secondary deployment charge */}
              {hasSecondaryDeploymentChargesPermission(
                "Secondary Deployment InCharges"
              ) &&
                hasMobileUsersPermission("Mobile Users") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/secondary-deployment-incharges"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/secondary-deployment-incharges"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Secondary Deployment Incharges")}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleSecondaryDeploymentInchargeClick}
                    />
                    {location.pathname ===
                      "/secondary-deployment-incharges" && <ActiveIndicator />}
                  </ListItem>
                )}
              {hasTransferstationInchargesPermission(
                "TransferStation InCharge"
              ) &&
                hasMobileUsersPermission("Mobile Users") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/transferstation-incharge"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/transferstation-incharge"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Transfer Station Incharges")}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleTransferStationInchargeClick}
                    />
                    {location.pathname === "/transferstation-incharge" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                )}

              {hasTrafficMarshalUserPermission(
                "Traffic Marshal"
              ) &&
                hasMobileUsersPermission("Mobile Users") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/traffic-marshal"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/traffic-marshal"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Traffic Marshal")}
                      style={{ paddingLeft: "25px" }}
                      onClick={handleTrafficMarshaltClick}
                    />
                    {location.pathname === "/traffic-marshal" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                )}
              {hasLoadingEquipmentDriverDetailsPermission(
                "Loading Equipment Driver Details"
              ) &&
                hasMobileUsersPermission("Mobile Users") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/loading-equipment-driver-details"
                      ? isProd
                        ? "active-ghmc"
                        : "active-swmnew"
                      : ""
                      }`}
                    component={NavLink}
                    to="/loading-equipment-driver-details"
                    style={{
                      borderRadius: "0px",
                      left: "1.5px",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("Loading Equipment Driver Details")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {location.pathname === "/loading-equipment-driver-details" && (
                      <ActiveIndicator />
                    )}
                  </ListItem>
                )}
            </Collapse>

            {hasMobileAPKsPermission("Mobile APK's") && (
              <ListItem
                onClick={() => sidebarMenuClose()}
                button
                className={`${classes.menuItem} ${location.pathname === "/mobile-apk's"
                  ? isProd
                    ? "active-ghmc"
                    : "active-swmnew"
                  : ""
                  }`}
                component={NavLink}
                to="/mobile-apk's"
                style={{
                  left: "1.5px",
                }}
              >
                <ListItemIcon
                  className={classes.menuItemIcon}

                >
                  {/* <i className="fa-solid fa-route"></i> */}
                  <i className={`fa-solid fa-file-arrow-down ${isProd ? "icon-blue" : "icon-red"}`}></i>
                </ListItemIcon>
                <ListItemText
                  inset
                  primary={("Mobile APK's")}
                  style={{ paddingLeft: "0px" }}
                />
                {location.pathname === "/mobile-apk's" && <ActiveIndicator />}
              </ListItem>
            )}
            <ListItem
              button
              component={NavLink}
              to="/"
              style={{
                // borderRadius: "0px",
                // // left: "2.5px",
                // // position: "relative",
                // // height :"2px",
                // // width:"100%",
                // bottom: "0",
                // // background :"#F9F9F9"
              }}
              onClick={() => {
                localStorage.clear();
                sidebarMenuClose()
              }}
            >
              <ListItemIcon>
                <i
                  className={`fa fa-sign-out-alt ${isProd ? "icon-blue" : "icon-red"}`}
                  style={{ marginLeft: "0px", }}
                ></i>{" "}
              </ListItemIcon>
              <ListItem button onClick={handleLogout}>
                <ListItemText primary="Logout" />
              </ListItem>
              {/* <IdleTimeoutModal  handleLogout={handleLogout}/> */}
            </ListItem>
          </List>
          {/* <Card style={{ borderRadius: '10px', background: '#F9F9F9' }}>
      <CardContent> */}
          {/* <div style={{height:"2px",width:"100%", color:"#E2E2E2"}}> */}

          {/* </div> */}
          {/* </CardContent>
    </Card> */}
          {isLoading && <Loader />}
        </div>
      </div>
    </div>
  );
};

const drawerWidth = "";
const useStyles = makeStyles((theme) =>
  createStyles({
    appMenu: {
      width: "100%",
    },
    navList: {
      width: drawerWidth,
    },
    menuItem: {
      width: drawerWidth,
      color: "black", // Set color to black
    },
    collapseInner: {
      backgroundColor: '#fff5f5'
    },
    nestedList: {
      position: "absolute",
      top: "0",
      left: "100%", // Positioning the nested list to the right of the parent item
      minWidth: "240px", // Adjust this width according to your design
      backgroundColor: "#fff", // Adjust background color if necessary
      boxShadow: "0 0 10px rgba(0,0,0,0.1)", // Optional: add a shadow for aesthetics
      zIndex: "999", // Ensure the nested list appears above other content
    },
    // menuItemIcon: {
    //   color: "#97c05c",
    // },
  })
);

const ActiveIndicator = () => (
  <div
    style={{
      display: "inline-block",
      content: '""',
      position: "absolute",
      right: 0,
      top: "50%",
      color: "#f2f2f2",
      // border: "15px solid transparent",
      borderRightColor: "#f4f5fd",
      marginTop: "-15px",
    }}
  />
);

export default withTranslation()(Sidebar);
